const DataEntrance = () => import('../../components/Tenant/DataEntrance/DataEntrance')

export default {
    path: 'tenant-data-entrances',
    redirect: 'tenant-data-entrances',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'tenant-data-entrances',
    meta: {'permissions': 'view-tenant-data-entrances'},
    children: [
        {
            path: '/',
            component: DataEntrance,
        },
    ],
};
